import api from '.';

export const atualizarFinalidade = (dados) => api.post('/censoPopulacional/finalidade', dados);
export const listarAbastecimentos = (params) => api.get('/censoPopulacional/abastecimentos', { params });
export const salvarAbastecimento = (dados) => api.post('/censoPopulacional/abastecimentos/salvar', dados);
export const excluirAbastecimento = (uuid) => api.post('/censoPopulacional/abastecimentos/excluir', { uuid });
export const listarFlutuante = (params) => api.get('/censoPopulacional/flutuante', { params });
export const salvarFlutuante = (dados) => api.post('/censoPopulacional/flutuante/salvar', dados);
export const excluirFlutuante = (uuid) => api.post('/censoPopulacional/flutuante/excluir', { uuid });
